import classNames from 'classnames';

import { Tooltip } from 'antd';
import styles from './styles.module.scss';

interface NamesListProps {
  names: string[];
}

export const NamesList = ({ names }: NamesListProps) => {
  if (!names || names.length === 0) return <div className={styles.clientName}>N/A</div>;

  const [first, second, ...rest] = names;

  return (
    <div className={styles.namesList}>
      <p className={styles.clientName}>{first}</p>
      {names.length === 2 && (
        <p className={classNames(styles.clientName, styles.secondClientName)}>{second}</p>
      )}
      {names.length > 2 && (
        <Tooltip
          color="black"
          placement="top"
          overlayClassName={styles.namesTooltip}
          title={
            <>
              {names.slice(1).map((name, index) => (
                <div key={index}>{name}</div>
              ))}
            </>
          }
        >
          <span className={styles.tooltipText}>+ {names.length - 1} more</span>
        </Tooltip>
      )}
    </div>
  );
};
